<template>
  <div class="app" id="app">
    <Header />
    <div class="app-container">
      <transition :name="transitionName" mode="out-in" @before-enter="beforeEnter">
        <router-view />
      </transition>
      <footer>
        <router-link :to="getTo('privacy')">
          {{ $t('privacy.privacy_policy') }}
        </router-link>
        <!-- <router-link :to="getTo('data-deletion')">
          {{ $t('privacy.data_deletion') }}
        </router-link>
        <router-link :to="getTo('terms-and-conditions')">
          {{ $t('privacy.terms_and_conditions') }}
        </router-link> -->
      </footer>
      <installation
        v-if="!installationOff && platform"
        :platform="platform"
        :deferredPrompt="deferredPrompt"
        @close="onInstallationClose"
        @install="install"
      />
      <cookies
        v-if="!cookiesOff"
        @close="onCookiesClose"
      />
    </div>
  </div>
</template>

<script>
// helpers
import { GUARDED_API_REQUEST_FAILED } from '@/helpers/constants';
import EventEmitter from '@/helpers/EventEmitter';

// partials
import Header from '@/components/Header.vue'
import Installation from '@/components/partials/Installation.vue';
import Cookies from '@/components/partials/Cookies.vue';
// import Account from '@/components/partials/Account.vue';

export default {
  components: {
    Installation,
    Cookies,
    Header,
    // Account
  },
  data() {
    return {
      installationOff: false,
      platform: null,
      deferredPrompt: null,
      cookiesOff: true,
      leaderboardDisplayed: false,
      accountDisplayed: false,
      signupDisplayed: false,
      transitionName: 'slide-right'
    };
  },

  async beforeMount() {
    const locale = localStorage.getItem('lang') || this.$route.params?.locale || 'ko';
    // const { locale } = this.$route.params || 'ko';
    document.documentElement.setAttribute('lang', locale);
    // Redirect to current exhibition
    if (this.$route.name === 'Root') {
      await this.$store.dispatch('exhibitions/getCurrent', { loc: locale });
    }

    // if (!this.logged) {
    //   if (this.$route.name === 'Chapter' || this.$route.name === 'Story') {
    //     if (this.$route.name === 'Chapter') {
    //       const { chapterId } = this.$route.params;
    //       localStorage.setItem('firstPage', chapterId);
    //       localStorage.setItem('firstPageType', this.$route.name);
    //     } else {
    //       const { storyId } = this.$route.params;
    //       localStorage.setItem('firstPage', storyId);
    //       localStorage.setItem('firstPageType', this.$route.name);
    //     }
    //   }
    //   if (this.$route.name === 'Privacy' || this.$route.name === 'DeleteData' || this.$route.name === 'NoExhibition' || this.$route.name === 'TermsAndConditions') {
    //     return;
    //   }
    // }

    const access_token = localStorage.getItem('access_token')
    
    if(!access_token) {
      await this.$store.dispatch('signup/register', { loc: locale });
      if (this.$route.name !== 'Login')  this.$router.push({ name: 'Login' });
    } else {
      await this.$store.dispatch('login/initRefreshTokenTimer');
      EventEmitter.on(GUARDED_API_REQUEST_FAILED, () => {
        console.log('GUARDED_API_REQUEST_FAILED, should re login');
        this.$store.commit('login/setLogged', false);
        if (this.$route.name !== 'Login') {
          this.$router.push({ name: 'Login' });
        }
      });
      if (await this.$store.dispatch('login/isLogged')) {
        this.$store.commit('login/setLogged', true);
        if (this.$route.name === 'Login') {
          this.$router.push({ name: 'Home' });
        }
      } else {
        this.$store.commit('login/setLogged', false);
        if (this.$route.name !== 'Login') {
          this.$router.push({ name: 'Login' });
        }
      }
    }
  },
  async mounted() {
    const cookiesOff = localStorage.getItem('cookies-off');
    if (!cookiesOff || cookiesOff !== 'true') {
      this.cookiesOff = false;
    }
  },
  created() {
    const installationOff = localStorage.getItem('installation-off');
    if (!installationOff || installationOff !== 'true') {
      if (window.matchMedia('(display-mode: standalone)').matches) {
        return;
      }
      this.installationOff = false;
      this.setPlatform();

      window.addEventListener('beforeinstallprompt', e => {
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
      });
      window.addEventListener('appinstalled', () => {
        this.deferredPrompt = null;
        this.onInstallationClose();
      });
    }
  },
  computed: {
     logged() {
      return this.$store.state.login.logged;
    },
  },
  methods: {
    getTo(name) {
      const locale = localStorage.getItem('lang') || 'ko';
      return `/${locale}/${name}`;
    },
    onCookiesClose() {
      this.cookiesOff = true; 
      localStorage.setItem('cookies-off', 'true');
    },
    onInstallationClose() {
      this.deferredPrompt = null;
      this.installationOff = true;
      localStorage.setItem('installation-off', 'true');
    },
    install() {
      this.deferredPrompt.prompt();
    },
    setPlatform() {
      const ua = window.navigator.userAgent;
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      const webkit = !!ua.match(/WebKit/i);
      const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

      if (iOS) {
        if (iOSSafari) {
          this.platform = 'ios';
        }

        return;
      }

      if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
        this.platform = 'android';
      }
    },
    beforeEnter() {
      window.scrollTo(0, 0);
    }
  },
  watch: {
    // eslint-disable-next-line
    '$route'(to, from) {
      const toDepth = to.path.split('/').length;
      const fromDepth = from.path.split('/').length;
      if (to.name === 'Error') {
        this.transitionName = 'fade';
      } else if (from.name === 'Login') {
        this.transitionName = 'slide-right';
      } else if (to.name === 'Login') {
        this.transitionName = 'slide-left';
      } else {
        this.transitionName = toDepth < fromDepth ? 'slide-left' : 'slide-right';
      }
    }
  }
};
</script>

<style lang="scss">
@import 'scss/reset';
@import 'scss/fonts';
@import 'scss/utils';
@import 'scss/typeset';

body {
  @include size(100%, auto);
  @include font('primary', 'regular');
  min-height: 100vh;
  background-color: $primary;
  color: $tertiary;
  font-size: rem(12px);
  line-height: 1.666;

  &.has-open-modal {
    overflow: hidden;
    position: fixed;
    width: 100%;
  }
}

.container {
  @include margin(null auto);
  @include padding(null $gs-padding);
  width: 100%;
  max-width: $gs-container;
  overflow: hidden;
}

.app {
  &-container {
    position: relative;
    @include margin(null auto);
    width: 100%;
    max-width: $gs-container;
    min-height: 100vh;
    overflow: hidden;
  }

  footer {
    padding: 0 15px 20px;
    text-align: center;
    a {
      margin: 0 5px;
      color: $tertiary;
      font-size: rem(10px);
    }
  }

  .view {
    min-height: 100vh;

    &.login + footer {
      padding: 0 15px 10px;
      @include position(absolute, null 0 0 0);
      z-index: 99;
    }
  }
}

// Typo

.h1,
.h2,
.h3,
.h4,
.h5 {
  @include font('secondary', 'regular');
  color: $tertiary;
  line-height: 1.333;
  text-transform: uppercase;
}

.h1 {
  color: $white;
  font-size: rem(28px);
}

.h2 {
  font-size: rem(20px);
}

.h3 {
  font-size: rem(14px);
}

.h4 {
  font-size: rem(11px);
}

.h5 {
  font-size: rem(10px);
}

.hat {
  @include font('secondary', 'regular');
  color: $secondary;
  font-size: rem(14px);
  line-height: .9;
  text-transform: uppercase;
}

.year-l,
.year-s {
  @include font('tertiary', 'regular');
  color: $secondary;
  line-height: 1.15;
}

.year {
  &-l {
    font-size: rem(50px);
  }

  &-s {
    font-size: rem(25px);
  }
}

//Transitions
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s $ease-out-quad;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transition: none;
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: all .3s $ease-out-quad;
}

.slide-right-enter-active {
  @include position(absolute, 0 0 null 0);
}

.slide-right-enter-to {
  transform: translateX(0);
}

.slide-right-enter {
  transform: translateX(100%);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translateX(-50%);
}

.slide-right-leave {
  transform: translateX(0);
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all .3s $ease-out-quad;
}

.slide-left-enter-active {
  @include position(absolute, 0 0 null 0);
}

.slide-left-enter-to {
  transform: translateX(0);
}

.slide-left-enter {
  transform: translateX(-100%);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translateX(50%);
}

.slide-left-leave {
  transform: translateX(0);
}
</style>
